export const currentEnvironment = process.env.VUE_APP_DEPLOY_ENV;
export const BO_URL = process.env.VUE_APP_BO_URI;
export const WORKSPACE_URI = process.env.VUE_APP_WORKSPACE_URI;
export const LAB_URI = process.env.VUE_APP_LAB_URI;
export const ACCOUNT_URL = process.env.VUE_APP_ACCOUNT_URI;
export const ACCOUNT_SERVICE_URL = process.env.VUE_APP_ACCOUNT_SERVICE_URI;
export const backofficeUrlBase = `${process.env.VUE_APP_BO_SERVICE_URI}` || '';
export const supersetUrlBase = process.env.VUE_APP_SUPERSET_URI;
export const publicPath = process.env.VUE_APP_PUBLIC_PATH || '/';
